/* oxlint-disable typescript/no-explicit-any */
import { isEmpty } from 'ramda';
import { IAddressSuggest, IMultiSuggestResult, IResultSuggestions } from '@cian/geosuggest-widget';

import { loadYmapsApi } from './ymaps';
import { ETargetPage } from '../types/page';

export interface IMultiSuggestParams {
  yandex: {
    apiKey: string;
    suggestApiKey: string;
    value: string;
    options?: {
      results: number;
    };
  };
  targetPage: ETargetPage;
}

export async function getMultiSuggest(params: IMultiSuggestParams): Promise<IMultiSuggestResult> {
  const {
    yandex: { value, apiKey, suggestApiKey },
  } = params;
  let yaSuggestResult: YMaps.ISuggestResult[] | YMaps.IScriptError | null = null;
  const suggestions: IResultSuggestions = {};

  const yandexSuggestApi = await loadYmapsApi({ require: ['suggest'] }, apiKey, suggestApiKey);

  try {
    yaSuggestResult = await yandexSuggestApi.suggest(value);
  } catch (e) {
    throw e;
  }

  if (!isEmpty(yaSuggestResult)) {
    suggestions.addresses = yaSuggestResult as IAddressSuggest[];
  }

  return {
    suggestions,
    sortOrder: ['addresses'],
  };
}
